import { withStyles } from "@material-ui/core/styles";
import React from "react";
import { Typography } from "@material-ui/core";
const styles = theme => ({
  textForm: {
    fontWeight: "400",
    fontSize: "0.875rem",
    lineHeight: "21px",
    letterSpacing: "-0.05px"
  }
});
class TextForm extends React.Component {
  render() {
    let { label = "", classes } = this.props;
    return <Typography className={classes.textForm}>{label}</Typography>;
  }
}

export default withStyles(styles)(TextForm);
